import { setVueContext } from 'src/common/context'
import fullscreen from 'src/common/fullscreen'
import loading from 'src/common/loading'
import notify from 'src/common/notify'
import platform from 'src/common/platform'

const $helpers = {
  platform,
  loading,
  fullscreen,
  notify: notify.notify,
}

export default {
  install(app) {
    app.config.globalProperties.$helpers = $helpers
    setVueContext(app)
  },
}
